import Suffix from "../Suffix";

export default class Unavailable {
  constructor(container) {
    this.container = container;

    container.addEventListener(
      "Product.itemNumber.change",
      this.productItemNumberChange
    );

    this.notifyMeForm = this.container.querySelector("[data-target=notifyMe]");

    if (this.notifyMeForm) {
      this.notifyMeForm.addEventListener("submit", this.handleOutOfStockSubmit);
    }
  }

  get html() {
    return this.cachedHTML || this.requestHTML();
  }

  get element() {
    return this.container.querySelector("[data-component=Unavailable]");
  }

  get errorMessageContainer() {
    return this.container.querySelector(
      "[data-component=errorMessageContainer]"
    );
  }

  get notifySuccessMessageContainer() {
    return this.container.querySelector("[data-target=notifySuccessMessage]");
  }

  handleOutOfStockSubmit = (event) => {
    event.preventDefault();

    const body = new FormData(this.notifyMeForm);

    body.append("isAjax", true);

    fetch("/template/site2012/pages/product_notify_form.cfm", {
      body,
      method: "POST",
    }).catch(this.outOfStockEmailError);

    this.container.querySelector("[data-target=notifyMeHeading]").hidden = true;
    this.notifyMeForm.hidden = true;
    this.notifySuccessMessageContainer.hidden = false;
  };

  outOfStockEmailError = () => {
    this.notifySuccessMessageContainer.hidden = true;
    this.errorMessageContainer.innerHTML =
      'Error sending email address. Please try again or email <a href="mailto:help@webstaurantstore.com"><strong>help@webstaurantstore.com</strong></a>.';
    this.errorMessageContainer.classList.remove("hide");
  };

  productItemNumberChange = (event) => {
    if (!this.element) return false;

    this.product = event.detail;
    this.suffix = Suffix.priceLookup(this.product.itemNumber);
    this.blockedByPlatinumPlusExclusive =
      this.suffix.isPlatinumPlusExclusive &&
      !this.suffix.customerIsPlatinumOrPlus;

    if (this.product.unavailable && !this.blockedByPlatinumPlusExclusive) {
      this.element.hidden = false;
      return this.render(this.product.itemNumber);
    }

    this.element.innerHTML = "";
    this.element.hidden = true;
    return Promise.resolve();
  };

  async requestHTML() {
    const body = new FormData();
    body.append("Client_Key", window.Token);
    body.append("item_number", this.product.itemNumber);
    body.append("description", this.element.dataset.description);
    body.append("ajax_request", true);
    body.append("_cf_nodebug", true);

    const result = await fetch("/ajax/renderUnavailableForm", {
      body,
      method: "POST",
      credentials: "include",
    });

    this.cachedHTML = await result.text();
    return this.cachedHTML;
  }

  async render() {
    this.element.innerHTML = await this.html;
  }
}
